var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoxRedCircled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145,
    height: 145,
    viewBox: "0 0 145 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74268",
    "data-name": "Group 74268",
    transform: "translate(-0.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_183",
    "data-name": "Ellipse 183",
    transform: "translate(0.264)",
    fill: "none",
    stroke: "#f91c1c",
    strokeWidth: 4,
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 72.5,
    r: 72.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 72.5,
    r: 70.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_74266",
    "data-name": "Group 74266",
    transform: "translate(1236.397 6504)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-1194 -6466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    d: "M61.08,111.173V68.85h51.7v42.323a2.183,2.183,0,0,1-.268,1.071,1.892,1.892,0,0,1-.669.134H62.016a1.892,1.892,0,0,1-.669-.134,2.146,2.146,0,0,1-.268-1.071ZM89.068,51.845h14.2a9.639,9.639,0,0,0,.894,1.649c.339.564.617,1.032.932,1.611.793,1.448,5.406,9.162,5.535,9.731H89.064V51.845Zm-18.482,0H84.915V64.836H63.221l1.816-3.274c.674-1.118,1.19-2.1,1.854-3.231s1.243-2.079,1.864-3.226C69.09,54.488,70.462,52.308,70.586,51.845ZM57.06,68.186v43.929a4.822,4.822,0,0,0,4.287,4.287h51.16a4.822,4.822,0,0,0,4.287-4.287V67.785c0-1.142-2.2-4.368-2.767-5.4-.511-.937-1.032-1.73-1.52-2.634L106.38,49.269a4.015,4.015,0,0,0-2.715-1.439H70.185c-2.256,0-3.341,2.38-4.278,4.024-1.032,1.8-2.055,3.58-3.078,5.358L59.8,62.489c-.76,1.257-2.739,4.211-2.739,5.7Z",
    transform: "translate(-57.06 -47.83)",
    fill: "#ff5252",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_25056c7970f449295eeb08b939ffe33b",
    "data-name": "25056c7970f449295eeb08b939ffe33b",
    d: "M16.2,6A2.2,2.2,0,0,0,14,8.2V19.214a2.2,2.2,0,0,0,4.4,0V8.2A2.2,2.2,0,0,0,16.2,6ZM14,25.82a2.2,2.2,0,1,0,2.2-2.2A2.2,2.2,0,0,0,14,25.82Z",
    transform: "translate(-1180.381 -6440.51)",
    fill: "#ff5252"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxRedCircled);
export default __webpack_public_path__ + "static/media/BoxRedCircled.2d7cdfb65f0df58a2ea1b777fbbacc08.svg";
export { ForwardRef as ReactComponent };